 
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  { path: '/', redirect: '/home' },
    {
    path: "/home",
    name: "Home",
    meta: {
      title: '泰順科技-代理系統',
    },
    component: () => import("../components/HelloWorld.vue"),
  },

  {
    path: "/expawb",
    name: "ExpAWB",
    meta: {
      title: '出口提單',
      requiresAuth: true
    },
    component: () => import("../components/ExpAWB.vue"),
  },
  {
    path: "/impawb",
    name: "ImpAWB",
    meta: {
      title: '進口提單',
      requiresAuth: true
    },
    component: () => import("../components/ImpAWB.vue"),
  },
  {
    path: "/areacodeaudio",
    name: "AreaCodeAudio",
    meta: {
      title: '分區播音設定',
      requiresAuth: true
    },
    component: () => import("../components/AreaCodeAudio.vue"),
  },
  {
    path: "/statusclear",
    name: "StatusClear",
    meta: {
      title: '清關分貨作業',
      requiresAuth: true
    },
    component: () => import("../components/StatusClear.vue"),
  },
  
  

 {
    path: "/login",
    name: "login",
    meta: {
      title: '登入',
    },
    component: () => import("../components/UserLogin.vue"),
  },
 

  /* {
    path: "/FAWMQ001",
    name: "公司廠區別維護",
    component: () => import("../components/FAWMQ001.vue"),
  },
  {
    path: "/FAWMQ004",
    name: "部門維護",
    component: () => import("../components/FAWMQ004.vue"),
  },
  {
    path: "/FAWMQ006",
    name: "控制標志維護",
    component: () => import("../components/FAWMQ006.vue"),
  },
  {
    path: "/FAWMQ007",
    name: "虛擬工號維護",
    component: () => import("../components/FAWMQ007.vue"),
  },
  {
    path: "/FAWMQ002",
    name: "會計科目維護",
    component: () => import("../components/FAWMQ002.vue"),
  },
  {
    path: "/FAWMQ017",
    name: "帳號維護",
    component: () => import("../components/FAWMQ017.vue"),
  },
  {
    path: "/FAWMQ021",
    name: "區域維護",
    component: () => import("../components/FAWMQ021.vue"),
  },
  {
    path: "/FAWMQ008",
    name: "資產分類維護",
    component: () => import("../components/FAWMQ008.vue"),
  },
  {
    path: "/FAWMQ022",
    name: "資產狀態維護",
    component: () => import("../components/FAWMQ022.vue"),
  },
  {
    path: "/FAWMQ003",
    name: "帳期維護",
    component: () => import("../components/FAWMQ003.vue"),
  },
  {
    path: "/FAWBQ011",
    name: "入賬批次維護(For NewType)",
    component: () => import("../components/FAWBQ011.vue"),
  },
  
  {
    path: "/FAWBQ010",
    name: "批次更新資產信息",
    component: () => import("../components/FAWBQ010.vue"),
  },
  {
    path: "/FAWBQ009",
    name: "保管部門批次更新維護",
    component: () => import("../components/FAWBQ009.vue"),
  },
  {
    path: "/FAWBQ006",
    name: "資產傳票",
    component: () => import("../components/FAWBQ006.vue"),
  },
  {
    path: "/FAWBQ008",
    name: "資產刪除批次維護",
    component: () => import("../components/FAWBQ008.vue"),
  },
  {
    path: "/FAWMQ023",
    name: "減值單筆維護",
    component: () => import("../components/FAWMQ023.vue"),
  },
  {
    path: "/FAWMQ016",
    name: "減損單筆維護",
    component: () => import("../components/FAWMQ016.vue"),
  },
  {
    path: "/FAWBQ004",
    name: "產生折舊",
    component: () => import("../components/FAWBQ004.vue"),
  },
  {
    path: "/FAWBQ005",
    name: "折舊回轉",
    component: () => import("../components/FAWBQ005.vue"),
  },
  {
    path: "/FAWBQ002",
    name: "移轉批次維護",
    component: () => import("../components/FAWBQ002.vue"),
  },
  {
    path: "/FAWMQ010",
    name: "減損原因維護",
    component: () => import("../components/FAWMQ010.vue"),
  },
  {
    path: "/FAWRQ003",
    name: "減損報表",
    component: () => import("../components/FAWRQ003.vue"),
  },
  {
    path: "/FAWRQ007",
    name: "財產目錄報表",
    component: () => import("../components/FAWRQ007.vue"),
  },
  {
    path: "/FAWRQ001",
    name: "固定資產報表",
    component: () => import("../components/FAWRQ001.vue"),
  },
  
  {
    path: "/FAWRQ007",
    name: "財產目錄報表",
    component: () => import("../components/FAWRQ007.vue"),
  },
  {
    path: "/FAWRQ008",
    name: "費用報表(月累計)",
    component: () => import("../components/FAWRQ008.vue"),
  },
  {
    path: "/FAWRQ002",
    name: "保管部門移轉報表",
    component: () => import("../components/FAWRQ002.vue"),
  }, */

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});


router.beforeEach(to => {

  if (to.matched.some(reocrd => reocrd.meta.requiresAuth)) {
    
    if(sessionStorage.getItem('user')) {
      return true;
    }
    else {
      return {
        path: '/login',
        query: { redirect: to.fullPath }
      }
    }

  }
  else {
    return true;
  }


})


router.afterEach((to) => {
  document.title = to.meta.title;
})

export default router;
